import {hideModalLoader, showModal, showModalLoader} from "./modal";
import {get, post} from "../modules/ajax";
import {fixAllContainerSVGs} from "../modules/svg";

export function showPopup()
{
    let modal = document.getElementById('personalized-text-pop-up');
    modal.querySelector('#personalized-text-pop-up-content').innerHTML = '';
    showModalLoader(modal);
    modal.querySelector('.modal-loader').classList.remove('bg-white');
    showModal('personalized-text-pop-up');
    get(
        '/ajax/website/product/get-personalized-text-pop-up',
        {},
        function(response) {
            modal.querySelector('#personalized-text-pop-up-content').innerHTML = response.modal;
            hideModalLoader(modal);
            let fontSelector = document.querySelector('#personalized-text-pop-up .font-selector');
            fontSelector.querySelectorAll('.font-group-title svg').forEach((svg) => svg.classList.add('h-20px'));
            fontSelector.querySelectorAll('.font-group-body svg').forEach((svg) => svg.classList.add('w-50'));
            fixAllContainerSVGs(fontSelector);
        }
    );
}

let renderPreviewAJAX;
export function getTextPreview(params)
{
    return new Promise(resolve => {
        if (renderPreviewAJAX && typeof renderPreviewAJAX == 'object') {
            renderPreviewAJAX.abort();
        }
        renderPreviewAJAX = post(
            '/ajax/website/personalized-services/render-personalized-text',
            params,
            function (data) {
                resolve(data.personalizedText);
            },
            function () {
                resolve(null);
            }
        )
    });
}